<template>
    <div class="dict-table-container p-3">
        <div class="dict-table-toolbar d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div class="d-flex align-items-center gap-2">
                <button type="button" class="btn action-btn action-btn--success" @click="this.dialogVis = true; this.editing = false">
                    <i class="bi bi-plus-lg"></i>
                    <span>Təzə yazı</span>
                </button>
                <button type="button" class="btn action-btn action-btn--muted" @click="this.$emit('get-data')">
                    <i class="bi bi-arrow-clockwise"></i>
                    <span>Yeniləmək</span>
                </button>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-3">
            <div class="table-responsive">
                <el-table border :data="this.data" class="el-table-css" style="width: 100%">
                    <el-table-column width="43">
                        <template #default="scope">
                            <el-button class="edit-btn"
                                @click="this.dialogVis = true; this.editing = true; this.object = scope.row"
                                style="color: #4db2e5; padding: 0 !important;" :icon="Edit" text />
                        </template>
                    </el-table-column>
                    <el-table-column prop="rejectTypeName" label="İmtinaya əsas" />
                    <el-table-column width="43">
                        <template #default="scope">
                            <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start"
                                title="Info" trigger="hover" class="edit-btn">
                                <template #reference>
                                    <el-button type="default"  style="padding: 0 !important;" :icon="InfoFilled"  text />
                                </template>
                                <template #default>
                                    <div>
                                        Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ scope.row.created }} <br>
                                        Düzəliş
                                        olunub &nbsp;&nbsp;&nbsp; {{ scope.row.updated }}
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column width="43">
                        <template #default="scope">
                            <el-button type="danger"  style="padding: 0 !important;" :icon="Delete"  class="edit-btn" @click="DeleteItem(scope.row)" text />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="this.editing ? 'İmtina əsası dəyişilməsi' : 'Yeni imtina əsası'"
        modal-class="modal-class" :destroy-on-close="true" width="30%" v-model="this.dialogVis">
        <Dialog @close-dialog="this.dialogVis = false" @insert-dialog="this.$emit('get-data'); this.dialogVis = false"
            :object="object" :editing="editing">
        </Dialog>
    </el-dialog>
</template>
<script>
import Dialog from "./Dialog.vue";
import {
    Delete,
    Edit,
    InfoFilled
} from "@element-plus/icons-vue";

export default {
    props: {
        data: Array
    },
    components: {
        Dialog
    },
    data() {
        return {
            type: null,
            dialogVis: false,
            Delete,
            Edit,
            page: 1,
            object: null,
            InfoFilled,
            editing: false,
            alert: false,

        }
    },
    methods: {
        async DeleteItem() {
            //None
        }
    }
}
</script>